import { KuposButton, KuposErrorSuccessModal, KuposInput } from '../../../common';
import React, { useState } from 'react';

import { AppData } from '../../../../services';
import CommonService from '../../../../services/commonService';
import ThemeTwoTitle from './ThemeTwoTitle';
import getIcons from '../../functions/getIcons/getIcons';

let initialState = {
	name: null,
	nameError: false,
	email: null,
	emailError: false,
	mobile: null,
	mobileError: false,
	message: null,
	messageError: false,
};

const ThemeTwoSpecialService = props => {
	let phoneNumberOne = '';
	let phoneNumberTwo = '';

	const [state, setState] = useState(initialState);

	if (
		(props.operator && props.operator.operator_name === 'barriaghisoni') ||
		(props.operator && props.operator.operator_name === 'combarbala') ||
		(props.operator && props.operator.operator_name === 'expresosantacruz')
	) {
		const temp = props.operator.phone_number.split('/');
		phoneNumberOne = temp[0];
		phoneNumberTwo = temp[1];
	}

	const onChange = (value, type) => {
		if (type == 'mobile') {
			value = CommonService.phoneNumberFormat(value);
			setState({
				...state,
				[type]: value,
				[type + 'Error']: false,
			});
		} else {
			setState({ ...state, [type]: value, [type + 'Error']: false });
		}
	};

	const validate = () => {
		let errorCount = 0;
		if (!state.name) {
			setState({ ...state, nameError: true, nameErrorMessage: 'Ingresa tu nombre' });
			errorCount++;
		} else if (!state.email) {
			setState({ ...state, emailError: true, emailErrorMessage: 'Ingrese un email valido' });
			errorCount++;
		} else if (state.email && !CommonService.isEMailValid(state.email)) {
			setState({ ...state, emailError: true, emailErrorMessage: 'Ingrese un email valido' });
			errorCount++;
		} else if (!state.mobile) {
			setState({
				...state,
				mobileError: true,
				mobileErrorMessage: 'Ingresa tu número de teléfono',
			});
			errorCount++;
		} else if (!state.message) {
			setState({
				...state,
				messageError: true,
				messageErrorMessage: 'Inserta tu comentario',
			});
			errorCount++;
		}

		if (errorCount > 0) {
			return false;
		} else {
			return true;
		}
	};

	const onSubmit = () => {
		if (!validate()) {
			return;
		}
		// Ensure form submission only for 'tarapaca' or 'santamaria'
		if (
			props.operator &&
			(props.operator.operator_name === 'tarapaca' ||
				props.operator.operator_name === 'santamaria' ||
				props.operator.operator_name === 'kennybus' ||
				props.operator.operator_name === 'barriaghisoni' ||
				props.operator.operator_name === 'cormarbus' ||
				props.operator.operator_name === 'serenamar' ||
				props.operator.operator_name === 'jetsur' ||
				props.operator.operator_name === 'viatur' ||
				props.operator.operator_name === 'combarbala' ||
				props.operator.operator_name === 'expresosantacruz' ||
				props.operator.operator_name === 'biaggini' ||
				props.operator.operator_name === 'lineaazul' ||
				props.operator.operator_name === 'santarosa')
		) {
			// Operators that require the last_name field
			const operatorsRequiringLastName = []; // Add the operators' names in Array that require last_name

			let data = {
				name: state.name,
				email: state.email,
				phone_number: state.mobile,
				comments: state.message,
				api_operator_id: props.operator.operator_id,
				operator_name: props.operator.operator_name,
			};

			// Add last_name to data if the current operator requires it
			if (operatorsRequiringLastName.includes(props.operator.operator_name) && state.last_name) {
				data.last_name = state.last_name;
			}

			{
				props.operator.operator_name === 'santarosa'
					? props.actions
						.apiCall({
							url: AppData.BASE_URL + 'api/special_service_request',
							method: 'POST',
							data: {
								special_service_request: data,
							},
						})
						.then(
							res => onContactInfoResponse(res),
							err => onContactInfoResponse(err),
						)
					: props.actions
						.apiCall({
							url: AppData.BASE_URL + 'api/opsite_contact_info',
							method: 'POST',
							data,
						})
						.then(
							res => onContactInfoResponse(res),
							err => onContactInfoResponse(err),
						);
			}
		}
	};

	const onContactInfoResponse = res => {
		if (res && res.data && res.data.message) {
			setState({
				...state,
				showModal: true,
				responseMessage: res.data.message,
				status: res.data.status,
			});
		}
	};
	return (
		props.operator && props.operator.operator_name === 'santarosa' ?

			(<div className="themes-theme-two-contact-section">

				<div
					className="form"
					style={{
						background:
							props.operator &&
							props.operator.color_codes &&
							props.operator.color_codes.primary_color &&
							props.operator.color_codes.primary_color,
					}}
				>
					<div className="form-inputs ">
						<div className="contact-input-item">
							<div className="contact-input-label  bold-text">Nombre</div>
							<KuposInput
								type="text"
								onChange={value => onChange(value, 'name')}
								value={state.name}
								error={state.nameError}
								errorMessage={state.nameErrorMessage}
							// placeholder="Nombre"
							/>
						</div>
						<div className="contact-input-item mx-2">
							<div className="contact-input-label bold-text ">Correo electrónico</div>
							<KuposInput
								type="email"
								onChange={value => onChange(value, 'email')}
								value={state.email}
								error={state.emailError}
								errorMessage={state.emailErrorMessage}
							// placeholder="Email"
							/>
						</div>
						<div className="contact-input-item">
							<div className="contact-input-label  bold-text">Nº de contacto</div>
							<KuposInput
								type="number"
								onChange={value => onChange(value, 'mobile')}
								value={state.mobile}
								error={state.mobileError}
								errorMessage={state.mobileErrorMessage}
							//  placeholder="Nº de contacto"
							/>
						</div>
					</div>
					<div className="text-area-input mt-3">
						<div className="contact-input-label  bold-text">Mensaje</div>
						<textarea
							className="text-area "
							rows={4}
							onChange={event => onChange(event.target.value, 'message')}
							value={state.message}
						// placeholder="Mensaje"
						/>
						{state.messageError ? (
							<span className="error font8" style={{ color: 'red' }}>
								{state.messageErrorMessage}
							</span>
						) : null}
					</div>
					<div className="contact-button">
						{props.operator && props.operator.operator_name === 'combarbala' ? (
							<KuposButton
								operator={props.operator}
								className="button-padding grey-colour"
								onClick={() => {
									onSubmit();
								}}
							>
								ENVIAR
							</KuposButton>
						) : props.operator && props.operator.operator_name === 'santarosa' ? (
							<KuposButton
								operator={props.operator}
								className="button-padding santabutton"
								onClick={() => {
									onSubmit();
								}}
							>
								Enviar
							</KuposButton>
						) : (
							<KuposButton
								operator={props.operator}
								className="button-padding"
								onClick={() => {
									onSubmit();
								}}
							>
								ENVIAR
							</KuposButton>
						)}
					</div>
				</div>
				<KuposErrorSuccessModal
					success={state.status == 200 ? true : false}
					showModal={state.showModal}
					onButtonClick={() => {
						setState({ showModal: false });
						window.location.reload();
					}}
					bodyText={state.responseMessage}
				/>
			</div>) : (<div className="themes-theme-two-contact-section new-container">
				<div
					className="info d-flex align-items-center"
					style={{
						color:
							props.operator &&
								props.operator.color_codes &&
								props.operator.color_codes.tertiary_text_color
								? props.operator.color_codes.tertiary_text_color
								: '',
					}}
				>
					{/* <ThemeTwoTitle operator={props.operator} id={'Servicio especiales'} smallHeading="Servicio especiales" rightLine /> */}

					{/* <div>

					{props.operator && props.operator.operator_name === 'santarosa' ?
						(<div className='formtitle'>
							<span>Servicio especiales</span>
							<div class="line right rosaline"><img src="/assets/santarosa/icons/line.svg" alt="" /></div>
						</div>) : (" ")}


					<div className="info-item">
						<span
							style={{
								display: 'block',
								textAlign: 'justify',
								fontSize: '15px',
								paddingRight: '20px',
								paddingBottom: '20px',
							}}
						>
							¿Necesitas solicitar una cotización para servicios especiales? Te invitamos a ponerte
							en contacto por medio de nuestro formulario de cotizaciones y felices te atenderemos.
						</span>
					</div>
					{props.operator && props.operator.phone_number ? (
						<div className="info-item ">
							<img src={getIcons('Headphone', props.operator)} alt="" />
							<span className="info-text ">
								Teléfono: {props.operator && props.operator.phone_number}
							</span>
						</div>
					) : null}

					{props.operator && props.operator.email ? (
						<div className="info-item bold-text">
							<img src={getIcons('Email', props.operator)} alt="" />
							<span className="info-text">Email: {props.operator.email}</span>
						</div>
					) : null}
				</div> */}
				</div>
				<div
					className="form"
					style={{
						background:
							props.operator &&
							props.operator.color_codes &&
							props.operator.color_codes.primary_color &&
							props.operator.color_codes.primary_color,
					}}
				>
					<div className="form-inputs ">
						<div className="contact-input-item">
							<div className="contact-input-label  bold-text">Nombre</div>
							<KuposInput
								type="text"
								onChange={value => onChange(value, 'name')}
								value={state.name}
								error={state.nameError}
								errorMessage={state.nameErrorMessage}
							// placeholder="Nombre"
							/>
						</div>
						<div className="contact-input-item mx-2">
							<div className="contact-input-label bold-text ">Email</div>
							<KuposInput
								type="email"
								onChange={value => onChange(value, 'email')}
								value={state.email}
								error={state.emailError}
								errorMessage={state.emailErrorMessage}
							// placeholder="Email"
							/>
						</div>
						<div className="contact-input-item">
							<div className="contact-input-label  bold-text">Nº de contacto</div>
							<KuposInput
								type="number"
								onChange={value => onChange(value, 'mobile')}
								value={state.mobile}
								error={state.mobileError}
								errorMessage={state.mobileErrorMessage}
							//  placeholder="Nº de contacto"
							/>
						</div>
					</div>
					<div className="text-area-input mt-3">
						<div className="contact-input-label  bold-text">Mensaje</div>
						<textarea
							className="text-area "
							rows={4}
							onChange={event => onChange(event.target.value, 'message')}
							value={state.message}
						// placeholder="Mensaje"
						/>
						{state.messageError ? (
							<span className="error font8" style={{ color: 'red' }}>
								{state.messageErrorMessage}
							</span>
						) : null}
					</div>
					<div className="contact-button">
						{props.operator && props.operator.operator_name === 'combarbala' ? (
							<KuposButton
								operator={props.operator}
								className="button-padding grey-colour"
								onClick={() => {
									onSubmit();
								}}
							>
								ENVIAR
							</KuposButton>
						) : props.operator && props.operator.operator_name === 'santarosa' ? (
							<KuposButton
								operator={props.operator}
								className="button-padding santabutton"
								onClick={() => {
									onSubmit();
								}}
							>
								Enviar
							</KuposButton>
						) : (
							<KuposButton
								operator={props.operator}
								className="button-padding"
								onClick={() => {
									onSubmit();
								}}
							>
								ENVIAR
							</KuposButton>
						)}
					</div>
				</div>
				<KuposErrorSuccessModal
					success={state.status == 200 ? true : false}
					showModal={state.showModal}
					onButtonClick={() => {
						setState({ showModal: false });
						window.location.reload();
					}}
					bodyText={state.responseMessage}
				/>
			</div>)
	);
};

export default ThemeTwoSpecialService;



// WEBPACK FOOTER //
// ./src/features/themes/ThemeTwo/common/ThemeTwoSpecialServices.js